import React, { useState, FC } from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { ProgressSpinner } from 'primereact/progressspinner';
import { getAccessToken } from '@/utils/auth';
import { decodeJWT } from '@/utils/decodeJWT';
import PrivateStopovers from '../PrivateStopovers/PrivateStopovers';
import { getBuque } from './getBuque';

type ModalChartProps = {
  codViaje?: number;
  buqueName?: string;
  armador?: string;
  servicio?: string;
  operaciones?: string;
};

const ModalChart: FC<ModalChartProps> = ({
  codViaje,
  buqueName,
  armador,
  servicio,
  operaciones,
}) => {
  const { t } = useTranslation('privateStopovers');
  const [isDialogShown, setIsDialogShown] = useState(false);
  const {
    data: chart,
    refetch,
    isFetching: isLoading,
  } = useQuery({
    queryKey: ['buque'],
    enabled: !!codViaje && isDialogShown,
    refetchInterval: 1000 * 60 * 60 * 24, // un dia
    refetchOnWindowFocus: false,
    queryFn: () => getBuque({ codViaje: `${codViaje}` }),
  });

  const accessToken = getAccessToken();
  const decodedJWTTokenData = accessToken ? decodeJWT(accessToken) : null;
  const armadores = decodedJWTTokenData?.armadores?.split(';') || [];

  const showEye =
    armadores.includes(armador || '') && servicio?.toUpperCase() !== 'RO-RO';

  const toggleDialog = () => {
    setIsDialogShown(!isDialogShown);
  };

  const onUpdateButtonClicked = () => {
    refetch();
  };

  return (
    <div>
      {showEye && (
        <FontAwesomeIcon
          icon={faEye}
          onClick={toggleDialog}
          style={{ cursor: 'pointer' }}
        />
      )}

      <Dialog
        header={
          <div className="flex flex-column">
            <span> {t('titleModal')} </span>
            <span>{buqueName}</span>
          </div>
        }
        visible={isDialogShown}
        style={{ width: '1200px', minHeight: '500px' }}
        breakpoints={{ '1200px': '95vw' }}
        onHide={toggleDialog}
      >
        {isLoading ? (
          <div className="w-full  h-25rem flex align-items-center justify-center">
            <ProgressSpinner />
          </div>
        ) : (
          <PrivateStopovers
            data={chart}
            onUpdate={onUpdateButtonClicked}
            operaciones={operaciones}
          />
        )}
      </Dialog>
    </div>
  );
};

export default ModalChart;
